import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Cas } from '../../core/entities/cas.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CasService {
    readonly BASE: any = PETICIONES.cas;

    constructor(private http: HttpClient) { }

  /**
   * @description
   * Obtiene todos los cas
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un cas por su id
   */
  public findById(id: number): Observable<any> {
    let idCas: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idCas).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un cas en la base de datos
   */
  public postCa(cas: Cas): Observable<any> {
    const json = JSON.stringify(cas);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postCas, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un cas en la base de datos
   */
  public deleteCa(cas: Cas): Observable<any> {
    let idcas: string = (cas.id !== undefined && cas.id !== null ? cas.id + "" : "");
    return this.http.get(this.BASE.deleteCas + "/" + idcas).pipe(delay(DELAY));
  }

}